import { query, collection, orderBy, onSnapshot, addDoc, setDoc, doc, deleteDoc } from "firebase/firestore";
import { getCompanyId, db, sendError } from "./firebase";

const listeners: CallableFunction[] = [];
var snapshotListener: Function | null = null;
var lastSnapshotList: any[] = [];

export function registerServiceSnapshotListener() {
    if (snapshotListener !== null){
        return;
    }
    const q = query(collection(db, 'companies/' + getCompanyId() + '/services'), orderBy("name"));
    //console.log("register serviceListener");
    snapshotListener = onSnapshot(q, (data: any) => {
        var list: { id: string; name: string; time: number; price: number; therapistPrice: number; groupClasses: boolean }[] = [];
        data.forEach(function (doc: any) {
            const d = doc.data();
            list.push({
                id: doc.id + "",
                name: d.name,
                time: d.time,
                price: d.price,
                therapistPrice: Number.isInteger(d.therapistPrice) ? d.therapistPrice : 0,
                groupClasses: d.groupClasses ?? false
            });
        });
        lastSnapshotList = list;
        listeners.forEach(callback => {
            callback(list);
        });


    }, (err) => {
        console.log("onServiceChange error => " + err.message);
        sendError(err.message);
    })
}
export async function unregisterServiceSnapshotListener(){
    if (snapshotListener !== null) {
        //console.log("unregister unregisterServiceSnapshotListener");
        await snapshotListener();
        snapshotListener = null;
    }
}

export async function addServiceListener(callback: CallableFunction) {
    listeners.push(callback);
    if (lastSnapshotList.length > 0) {
        callback(lastSnapshotList);
    }
}

export async function addService(data:{name:string; time?: number; price?: number; therapistPrice?: number; groupClasses?: boolean}){
    try {
        await addDoc(collection(db, 'companies/' + getCompanyId() + '/services'), data);
    } catch (error) {
        console.error(error);
        sendError("Nie mozna dodać Usługi!");
    }
}

export async function setService(data:{name:string; time?: number; price?: number; therapistPrice?: number; groupClasses?: boolean}, id: string){
    try {
        await setDoc(doc(db, 'companies/' + getCompanyId() + '/services', id), data, { merge: true });
    } catch (error) {
        console.error(error);
        sendError("Nie mozna poprawić Usługi!");
    }
}

export async function deleteService(id:string){
    try {
        await deleteDoc(doc(db, 'companies/' + getCompanyId() + '/services', id));
    } catch (error) {
        console.error(error);
        sendError("Nie mozna usunąć Usługi!");
    }
}

export function getServices() {
    return lastSnapshotList;
}

export function getService(id: string) {
    for(var i=0; i<lastSnapshotList.length; i++){
        if(lastSnapshotList[i].id === id){
            return lastSnapshotList[i];
        }
    }
    return null;

}